import gql from 'graphql-tag';

export default gql`
query ($id: String!) {
  getWebsite (id: $id) {
    __typename
    id
    name
    channelId
    channel {
      id
      name
    }
    purchaseModelIds
    purchaseModels {
      id
      name
    }
    formats
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Websites/GetQuery.js